import React from 'react'
import "./Hobbies.css";
import {hobbies} from "../../../../Constants/Constants";


function Hobbies() {
    const hobbyList = hobbies.map(hobby => (<li>{hobby}</li>));
    return (
        <div className="hobbies">
            <h2>Hobbies</h2>
            <h3>{hobbyList}</h3>

        </div>
    )
}

export default Hobbies
